"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _LoaderDots = _interopRequireDefault(require("../Loader/LoaderDots"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var variant = _ref.variant,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      children = _ref.children,
      loading = _ref.loading,
      Element = _ref.as,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "onClick", "disabled", "icon", "iconPosition", "children", "loading", "as"]);

  var ButtonIcon = (0, _themeUi.jsx)(_Icon["default"], {
    icon: icon,
    size: 2,
    sx: {
      color: 'inherit'
    }
  });
  return (0, _themeUi.jsx)(Element, _extends({}, props, {
    disabled: loading || disabled,
    onClick: loading || disabled ? null : onClick,
    sx: _extends({
      cursor: loading || disabled ? 'default' : 'pointer',
      pointerEvents: loading || disabled ? 'none' : 'auto',
      textTransform: 'uppercase',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 'medium',
      px: 3,
      py: 2,
      fontFamily: 'body',
      fontSize: 1,
      fontWeight: 'bold',
      lineHeight: 'normal',
      letterSpacing: 'loose',
      outline: 'none',
      borderWidth: 'thin',
      borderStyle: 'solid',
      variant: "buttons.Button." + variant,
      transition: function transition(theme) {
        return "box-shadow 200ms " + theme.easing.quickToSlow;
      }
    }, loading && {
      ':disabled': {},
      ':hover': {},
      ':active': {}
    })
  }), (0, _themeUi.jsx)("span", {
    sx: {
      position: 'relative',
      display: 'block'
    }
  }, loading && (0, _themeUi.jsx)(_LoaderDots["default"], {
    "aria-label": "loading",
    sx: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    animationDelay: 200
  }), (0, _themeUi.jsx)("span", {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: loading ? 0 : 1,
      transform: loading ? 'scaleX(0.4) scaleY(0.7)' : 'scaleX(1) scaleY(1)',
      transition: function transition(theme) {
        return "opacity 120ms " + theme.easing.slowToQuick + ", transform 120ms " + theme.easing.slowToQuick;
      }
    }
  }, icon && iconPosition === 'left' && (0, _themeUi.jsx)("span", {
    sx: {
      display: 'block',
      mr: 2
    }
  }, ButtonIcon), (0, _themeUi.jsx)("span", {
    sx: {
      display: 'block'
    }
  }, children), icon && iconPosition === 'right' && (0, _themeUi.jsx)("span", {
    sx: {
      display: 'block',
      ml: 2
    }
  }, ButtonIcon))));
};

Button.propTypes = {
  variant: _propTypes["default"].oneOf(['primary', 'secondary', 'outlined', 'text']),
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  icon: _propTypes["default"].func,
  iconPosition: _propTypes["default"].oneOf(['left', 'right']),
  children: _propTypes["default"].node,
  loading: _propTypes["default"].bool,
  as: _propTypes["default"].node
};
Button.defaultProps = {
  variant: 'primary',
  iconPosition: 'left',
  onClick: null,
  as: 'button'
};
var _default = Button;
exports["default"] = _default;